require('../modules/es6.symbol');
require('../modules/es6.object.to-string');
module.exports = require('../modules/_core').Symbol;


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/taxpadweb/~/core-js/es6/symbol.js
// module id = ../../../../core-js/es6/symbol.js
// module chunks = 1